
import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS } from '../../../../constants';
import request from '../../../../components/Utils/httpHelper';
import {
    OVERRIDDING_RISKFACTOR_LIST,
    overriddingRiskFactorListSuccess,
    overriddingRiskFactorListFailure
} from './action';
import { SCORE_DEFINATION } from '../../../../config';

export function* overiddingRiskFactorList(action) {
    let requestUrl = `${SCORE_DEFINATION}/overridingriskfactor/list`;
    try {
        const createResult = yield call(request, requestUrl, { data: '', method:'GET', headers: HTTP_HEADERS });
        yield put(overriddingRiskFactorListSuccess(createResult));
    } catch (err) {
        yield put(overriddingRiskFactorListFailure(err))
    }
}
export function* listOveriddingRiskFactor() {
    yield takeLatest(OVERRIDDING_RISKFACTOR_LIST, overiddingRiskFactorList);
}